import { render } from "./Puntate.vue?vue&type=template&id=45e4554a"
import script from "./Puntate.vue?vue&type=script&lang=js"
export * from "./Puntate.vue?vue&type=script&lang=js"

import "./Puntate.vue?vue&type=style&index=0&id=45e4554a&lang=css"

import exportComponent from "D:\\Hobby\\Javascript\\Sito_AS\\aperispeak\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__